module.exports = __webpack_public_path__ + "media/images/admin-icons-8e502b75091e086fcd309c591840b0a4.png";